import { GeneratedContent } from "@/types/content";
import { formatDistanceToNow } from "date-fns";
import { MessageCircle, Heart, Share2 } from "lucide-react";

export const LinkedInPreview = ({ content }: { content: GeneratedContent }) => {
  return (
    <div className="max-w-[550px] mx-auto">
      <div className="bg-white dark:bg-gray-900 rounded-xl p-6 border border-gray-200 dark:border-gray-800">
        <div className="flex items-start gap-4">
          <div className="w-14 h-14 rounded-full bg-gray-200 dark:bg-gray-800" />
          <div className="flex-1">
            <div className="space-y-1">
              <h3 className="font-semibold">Your Name</h3>
              <p className="text-sm text-gray-500">Your Title</p>
              <p className="text-sm text-gray-500">
                {formatDistanceToNow(new Date(), { addSuffix: true })}
              </p>
            </div>
            
            <div className="mt-4 text-[15px] whitespace-pre-wrap">
              {content.content}
            </div>

            <div className="mt-6 flex items-center gap-6 text-gray-500">
              <button className="flex items-center gap-2 hover:text-blue-600">
                <Heart className="h-5 w-5" />
                <span>Like</span>
              </button>
              <button className="flex items-center gap-2 hover:text-blue-600">
                <MessageCircle className="h-5 w-5" />
                <span>Comment</span>
              </button>
              <button className="flex items-center gap-2 hover:text-blue-600">
                <Share2 className="h-5 w-5" />
                <span>Share</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 